import fetchWrapper from "@/api/fetch-wrapper";

export const getAddressesByString = (addressPart) => {
    const query = `ajax/addressIntegrationDadata.php?address=${addressPart}`;
    
    return fetchWrapper.get(query);
}